import { BackToTop } from "../ui/backToTop";
import { Comments } from "./comments";
import { Content } from "./content";
import { CopyLink } from "./copyLink";
import { Favorite } from "./favorite";
import { FeatureMedia } from "./featureMedia";
import { Like } from "./like";
import { ReadingProgress } from "./readingProgress";
import { WechatShare } from "./wechatShare";

export class Article {
  static compiler() {
    Comments.compiler("#comments");
    // 文章内容增强（语法高亮 + 表格响应式）
    Content.compiler(".article-content");
    // 复制链接
    CopyLink.compiler(".copy-link");
    // 文章收藏
    Favorite.compiler(".article-favorite");
    // 文章点赞
    Like.compiler(".article-like");
    // 微信分享二维码
    WechatShare.compiler(".wechat-share");
    // 文章特色媒体
    FeatureMedia.compiler("[data-feature-media]");
    // 返回顶部
    BackToTop.compiler("#back-to-top");
    // 文章阅读进度条
    ReadingProgress.compiler(".article-content");
  }
}
